module.exports = "/_next/static/images/en_1-ac4e0cb58fd178b4af6d4a8f955f6421.jpg";